$(document).ready(function () {
    let getAdditionalScrollContainer = function (tableContainer) {
        let additionalScrollContainer = tableContainer.prev('.table-top-scroll');

        if (!additionalScrollContainer.length) {
            additionalScrollContainer = $('<div class="table-top-scroll"><div>&nbsp;</div></div>');
            tableContainer.before(additionalScrollContainer);
        }

        return additionalScrollContainer;
    };

    let getTableScrollTarget = function (tableContainer) {
        let dataTableScrollBody = tableContainer.find('.dataTables_scrollBody').first();

        if (dataTableScrollBody.length) {
            tableContainer.css('overflow-x', 'visible');

            return dataTableScrollBody;
        }

        let dataTableContent = tableContainer.find('.dataTables_wrapper > .top').first();

        if (dataTableContent.length) {
            tableContainer.css('overflow-x', 'visible');
            dataTableContent.css({
                'overflow-x': 'auto',
                'overflow-y': 'hidden',
                'width': '100%'
            });

            return dataTableContent;
        }

        return tableContainer;
    };

    let refreshTableTopScroll = function (tableContainer) {
        tableContainer = $(tableContainer);

        if (!tableContainer.length) {
            return;
        }

        let additionalScrollContainer = getAdditionalScrollContainer(tableContainer);
        let additionalScrollDiv = additionalScrollContainer.find('div').first();
        let scrollTarget = getTableScrollTarget(tableContainer);
        let table = scrollTarget.find('table').first();

        if (!additionalScrollContainer.length || !additionalScrollDiv.length || !table.length) {
            return;
        }

        let container = scrollTarget.get(0);
        let scrollWidth = Math.max(container.scrollWidth, table.outerWidth());

        additionalScrollDiv.width(scrollWidth);
        additionalScrollContainer.scrollLeft(scrollTarget.scrollLeft());
        additionalScrollContainer.toggle(scrollWidth > scrollTarget.innerWidth());
    };

    let initTableTopScroll = function () {
        $('.js-table-additional-scroll').each(function (index, container) {
            let tableContainer = $(container);
            let additionalScrollContainer = getAdditionalScrollContainer(tableContainer);
            let scrollTarget = getTableScrollTarget(tableContainer);

            if (!additionalScrollContainer.length || !scrollTarget.length) {
                return;
            }

            if (tableContainer.data('tableTopScrollTarget') !== scrollTarget.get(0)) {
                additionalScrollContainer.off('scroll.tableTopScroll');
                tableContainer
                    .add(scrollTarget)
                    .off('scroll.tableTopScroll');

                let topLeftSetByCode = null;
                let targetLeftSetByCode = null;

                let moveScroll = function (destination, left) {
                    let before = destination.scrollLeft();

                    destination.scrollLeft(left);

                    let after = destination.scrollLeft();

                    return after !== before ? after : null;
                };

                additionalScrollContainer.on('scroll.tableTopScroll', function () {
                    let left = additionalScrollContainer.scrollLeft();

                    if (left === topLeftSetByCode) {
                        topLeftSetByCode = null;

                        return;
                    }

                    targetLeftSetByCode = moveScroll(scrollTarget, left);
                });

                scrollTarget.on('scroll.tableTopScroll', function () {
                    let left = scrollTarget.scrollLeft();

                    if (left === targetLeftSetByCode) {
                        targetLeftSetByCode = null;

                        return;
                    }

                    topLeftSetByCode = moveScroll(additionalScrollContainer, left);
                });

                tableContainer.data('tableTopScrollTarget', scrollTarget.get(0));
            }

            refreshTableTopScroll(tableContainer);
        });
    };

    initTableTopScroll();

    $(window).on('resize.tableTopScroll', initTableTopScroll);
    $(document).ajaxComplete(function () {
        setTimeout(initTableTopScroll, 0);
    });

    $(document).on('init.dt draw.dt xhr.dt column-sizing.dt responsive-resize.dt shown.bs.tab shown.bs.modal', function () {
        setTimeout(initTableTopScroll, 0);
    });
});
